/**
 * Here is where to import each one of the incoming
 * packages/modules/libraries, etc. Its also possible to
 * create multiple files for each single module, the vue instance
 * is available in each file of this directory
 */


import ECharts from 'vue-echarts';
import Antd from 'ant-design-vue';
import { EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap';
import lazyLoad from '@/directives/img-lazyload';
import clickOutside from '@/directives/click-outside';
import ImageLoader from '@/components/ImageLoader';
import ItemCounterCharger from '@/components/ItemCounterCharger';

export default ({ vue }) => {
    vue.use(Antd);
    vue.component('v-chart', ECharts);
    vue.component('imageLoader', ImageLoader);
    vue.directive('lazyload', lazyLoad);
    vue.directive('click-outside', clickOutside);
    vue.component('item-counter-charger', ItemCounterCharger);
    vue.component('editor-content', EditorContent);
    vue.component('editor-menu-bar', EditorMenuBar);
    vue.component('editor-menu-bubble', EditorMenuBubble);
}